import { type ButtonProps } from 'antd5';
import { type ButtonGroupProps } from 'antd5/lib/button/button-group';
import { forwardRef } from 'react';

import { StyledButton } from './Button.style';

const Button = forwardRef<HTMLButtonElement, any>(function Button({ ...props }: ButtonProps, ref) {
  return <StyledButton ref={ref} {...props} />;
});

export function ButtonGroup({ ...props }: ButtonGroupProps) {
  return <StyledButton.Group {...props} />;
}

const ButtonNamespace = Object.assign(Button, { Group: ButtonGroup });

export { ButtonNamespace as Button };
